// Importing React to build the component.
import React, { useEffect, useState } from 'react';

// Importing the Bootstrap Card component.
import Card from 'react-bootstrap/Card';

// Importing the CSS file for styling the profile page.
import '../ProfilePage.css';

// Importing the APIService to fetch user data.
import APIService from '../APIService';

// ProfileCard component: Displays the user's profile, including first name,
// last name, unique ID, and major.
function ProfileCard() {
    // State to store user data
    const [userData, setUserData] = useState({
        first_name: '',
        last_name: '',
        unique_id: '',
        major: '',
        academic_year: ''
    });

    // Mapping for academic year to string
    const academicYearMapping = {
        1: 'Freshman',
        2: 'Sophomore',
        3: 'Junior',
        4: 'Senior'
    };

    // Fetch user data from the API using APIService
    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const data = await APIService.GetCurrentUser();
                if (data) {
                    setUserData(data);
                } else {
                    console.error('Failed to fetch user data');
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
            }
        };

        fetchUserData();
    }, []);

    return (
        <Card className="profile-page-card rounded-0">
            <Card.Body>
                <Card.Title className="profile-page-card-title">
                    Profile
                </Card.Title>
                <Card.Text>
                    <b>First Name: </b>{userData.first_name || 'N/A'}
                </Card.Text>
                <Card.Text>
                    <b>Last Name: </b>{userData.last_name || 'N/A'}
                </Card.Text>
                <Card.Text>
                    <b>Unique ID: </b>{userData.unique_id || 'N/A'}
                </Card.Text>
                <Card.Text>
                    <b>Major: </b>{userData.major || 'N/A'}
                </Card.Text>
                <Card.Text>
                    <b>Academic Year: </b>
                    {academicYearMapping[userData.academic_year] || 'N/A'}
                </Card.Text>
            </Card.Body>
        </Card>
    );
}

// Exporting the ProfileCard component so it can be imported and used in other
// parts of the app.
export default ProfileCard;